import { defaultConfig } from '@chakra-ui/react/preset';
import { createSystem, defineConfig } from '@chakra-ui/react/styled-system';

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: '#e3f7f1' },
          100: { value: '#c2eadf' },
          200: { value: '#9fdcc9' },
          300: { value: '#7ccfb3' },
          400: { value: '#56c29d' },
          500: { value: '#0C8A6F' },
          600: { value: '#0A755F' },
          700: { value: '#075f50' },
          800: { value: '#054a41' },
          900: { value: '#033430' },
        },
      },
    },
    semanticTokens: {
      colors: {
        primary: {
          contrast: { value: 'white' },
          fg: { value: { _light: '{colors.primary.700}', _dark: '{colors.primary.300}' } },
          subtle: { value: { _light: '{colors.primary.100}', _dark: '{colors.primary.900}' } },
          muted: { value: { _light: '{colors.primary.200}', _dark: '{colors.primary.800}' } },
          emphasized: { value: { _light: '{colors.primary.300}', _dark: '{colors.primary.700}' } },
          solid: { value: { _light: '{colors.primary.600}', _dark: '{colors.primary.500}' } },
          focusRing: { value: '{colors.primary.500}' },
        },
        card: {
          bg: { value: { _light: 'white', _dark: '{colors.gray.800}' } },
          border: { value: { _light: '{colors.gray.200}', _dark: '{colors.gray.600}' } },
        },
      },
    },
  },
  globalCss: {
    body: {
      bg: { _light: 'gray.50', _dark: 'gray.900' },
      color: { _light: 'gray.900', _dark: 'gray.300' },
    },
  },
});

export default createSystem(defaultConfig, config);
